import React, { Component } from "react";
import {
  Sidebar
} from "../library/Sidebar";

class TimesheetsSidebar extends Component {
  render() {
    return (
      <div>
        <Sidebar name="Timesheets" onSelect={this.closeSubNav} isLineManager={this.props.isLineManager}>
          {({ close }) => (
            <div />
          )}
        </Sidebar>
      </div>
    );
  }
}

export default TimesheetsSidebar;
